import script from "./AdminVacancyDrafts.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminVacancyDrafts.vue?vue&type=script&setup=true&lang=js"

import "./AdminVacancyDrafts.vue?vue&type=style&index=0&id=7a11b538&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a11b538"]])

export default __exports__